(function () {
  'use strict';
  if (customElements.get('cl-november-shop')) return;
  const money = amount => window.CraftlabelNovember.money(amount);
  const aggregate = variants => [...variants.reduce((map, variant) => map.set(variant.id, (map.get(variant.id) || 0) + 1), new Map())].map(([id, quantity]) => ({ id, quantity }));

  class NovemberShop extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('cl-november');
      this.dialog = this.querySelector('.cl-nov__dialog');
      this.viewport = this.closest('[data-nov-viewport]');
      this.world = this.viewport.querySelector('[data-nov-world]');
      this.curtain = this.viewport.querySelector('.cl-nov__camera-curtain');
      this.imageCache = new Map();
      this.anchor = this.viewport.parentElement;
      this.opened = false;
      this.form = this.querySelector('form');
      this.add = this.querySelector('[data-w1-add]');
      this.feedback = this.querySelector('[data-w1-feedback]');
      this.cartLink = this.querySelector('[data-w1-cart]');
      this.strings = JSON.parse(this.querySelector('[data-w1-strings]').textContent);
      this.catalog = JSON.parse(this.querySelector('[data-w1-catalog]').textContent);
      this.offerCode = this.dataset.offerCode;
      this.ensemble = this.root.querySelector(this.offerCode ? '[data-code="' + CSS.escape(this.offerCode) + '"] [data-w1-ensemble]' : '[data-w1-ensemble]');
      this.home = this.ensemble?.parentElement;
      this.card = this.ensemble?.closest('[data-nov-offer]');
      if (!this.card) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.gsap = window.gsap;
      this.hoverMedia = matchMedia('(hover: hover) and (pointer: fine)');
      this.key = this.offerCode ? 'craftlabel-november-' + this.offerCode.toLowerCase() + '-purple-v1' : 'craftlabel-november-w1-v2';
      this.slots = this.catalog.slots || [
        { products: this.catalog.knits, handle: 'siyah-triko-polo-yaka-tisort', size: '' },
        { products: this.catalog.knits, handle: 'ekru-triko-polo-yaka-tisort', size: '' },
        { products: this.catalog.tees, handle: 'beyaz-bisiklet-yaka', size: '' }
      ];
      if (this.catalog.slots) this.slots.forEach(slot => {
        if (!slot.products.some(p => p.handle === slot.handle && p.variants.some(v => v.available))) slot.handle = (slot.products.find(p => p.variants.some(v => v.available)) || slot.products[0])?.handle || '';
      });
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.key) || '{}');
        this.pending = saved.pending;
        saved.slots?.forEach((value, index) => {
          const slot = this.slots[index];
          if (slot?.products.some(product => product.handle === value.handle)) Object.assign(slot, { handle: value.handle, size: value.size });
        });
      } catch (_) { /* Storage can be unavailable in private browsing. */ }
      this.fields = [...this.querySelectorAll('[data-w1-slot]')];
      this.tabs = [...this.querySelectorAll('[data-slot-edit]')];
      this.activeSlot = 0;
      this.depth = { back:this.card.querySelector('[data-scene-back]'), mid:this.card.querySelector('[data-scene-mid]'), front:this.card.querySelector('[data-scene-front]') };
      this.productLight = this.card.querySelector('[data-product-light]');
      this.tabs.forEach((tab,index)=>tab.addEventListener('click',()=>this.setActive(index),{signal}));
      this.ensemble.querySelectorAll('[data-stage-edit]').forEach(button=>button.addEventListener('click',()=>this.setActive(Number(button.dataset.stageEdit),true),{signal}));
      this.fields.forEach((field, index) => {
        const slot = this.slots[index];
        const select = field.querySelector('select');
        select.replaceChildren();
        slot.products.forEach(product => {
          const option = new Option(product.color, product.handle);
          option.disabled = !product.variants.some(variant => variant.available);
          if (option.disabled) option.textContent += ' — ' + this.strings.sold_out;
          select.add(option);
        });
        select.value = slot.handle;
        this.renderSlot(index);
        select.addEventListener('change', () => {
          slot.handle = select.value;
          const product = this.product(index);
          const previousSize = slot.size;
          if (!product?.variants.some(v => v.size === slot.size && v.available)) slot.size = '';
          this.renderSlot(index);
          field.querySelector('[data-slot-handle="' + CSS.escape(slot.handle) + '"]')?.focus({ preventScroll: true });
          if (previousSize && !slot.size) this.error(index, this.strings.size_reset);
          this.persist();
          this.updateSummary();
        }, { signal });
        field.addEventListener('click', event => {
          const color = event.target.closest('[data-slot-handle]');
          if (color && !color.disabled && !this.busy) { select.value = color.dataset.slotHandle; select.dispatchEvent(new Event('change')); return; }
          const button = event.target.closest('[data-slot-size]');
          if (!button || button.disabled) return;
          slot.size = button.dataset.slotSize;
          this.renderSlot(index, false);
          field.querySelector(`[data-slot-size="${CSS.escape(slot.size)}"]`)?.focus({ preventScroll: true });
          this.persist();
          this.updateSummary();
        }, { signal });
      });
      this.root.addEventListener('click', event => {
        const button = event.target.closest('[data-w1-open], [data-w1-zoom]');
        if (button && (!this.offerCode || this.card.contains(button))) this.open(button);
      }, { signal });
      // Intent prefetch is limited to the three currently selected W1 products.
      this.card.addEventListener('pointerenter', () => this.warmImages(), { signal });
      this.card.addEventListener('focusin', () => this.warmImages(), { signal });
      this.querySelector('[data-w1-close]').addEventListener('click', () => this.close(), { signal });
      this.viewport.addEventListener('keydown', event => {
        if (!this.opened) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key !== 'Tab') return;
        const controls = [...this.viewport.querySelectorAll('button:not(:disabled), select:not(:disabled), a[href]')].filter(element => !element.closest('[inert]') && element.getClientRects().length && element.tabIndex>=0);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, { signal });
      this.media.addEventListener('change', () => {
        if (this.media.matches) { this.transition?.progress(1); this.resetHover(true); this.setDepth(this.opened,true); this.updateLighting(true); }
      }, { signal });
      window.addEventListener('resize', () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => { if (this.opened) this.reframe(); });
      }, { signal });
      this.setupHover(signal);
      this.timer = setInterval(() => { if (this.opened) this.updateSummary(); }, 1000);
      this.updateSummary();
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer); cancelAnimationFrame(this.resizeFrame);
      this.transition?.kill(); this.resetHover(true);
      this.visibilityObserver?.disconnect();
      this.gsap?.killTweensOf([...Object.values(this.depth || {}),this.productLight,...(this.ensemble?.children || [])].filter(Boolean));
      this.slots?.forEach(slot => { slot.imageRequest = (slot.imageRequest || 0) + 1; });
      this.hoverItems?.forEach(item => Object.values(item.to).forEach(tween => tween.tween?.kill()));
      this.ensemble?.querySelectorAll('img,.cl-nov__cutout').forEach(image => this.gsap?.killTweensOf(image));
      if (this.opened) this.finishClose(false);
    }

    setupHover(signal) {
      if (!this.gsap) return;
      this.hoverItems = [...this.root.querySelectorAll('[data-nov-offer]')].map(card => {
        const stage = card.querySelector('[data-nov-stage]');
        const layer = card.querySelector('.cl-nov__hover-layer'), light = card.querySelector('.cl-nov__bulb-glow');
        const to = {};
        for (const [key, target, prop] of [['rx',layer,'rotationX'],['ry',layer,'rotationY'],['y',layer,'y'],['glow',light,'opacity']]) {
          to[key] = this.gsap.quickTo(target, prop, { duration: key === 'glow' ? .8 : .45, ease: 'power3.out' });
        }
        const item = { card, layer, light, to };
        stage.addEventListener('pointermove', event => {
          if (this.opened || this.media.matches || !this.hoverMedia.matches || event.pointerType === 'touch') return;
          const bounds = stage.getBoundingClientRect();
          const x = Math.max(-.5,Math.min(.5,(event.clientX-bounds.left)/bounds.width-.5));
          const y = Math.max(-.5,Math.min(.5,(event.clientY-bounds.top)/bounds.height-.5));
          layer.style.willChange = 'transform';
          // Only the products tilt. Bulb coordinates stay locked to the artwork.
          to.rx(-y*6); to.ry(x*8); to.y(-3); to.glow(.8);
        }, { signal });
        stage.addEventListener('pointerleave', () => this.restHover(item), { signal });
        stage.addEventListener('focusin', () => { if (!this.media.matches) to.glow(.6); }, { signal });
        stage.addEventListener('focusout', () => this.restHover(item), { signal });
        return item;
      });
      // No ambient loop: offscreen cards and background tabs have no running effects.
      this.visibilityObserver = new IntersectionObserver(entries => {
        entries.filter(entry => !entry.isIntersecting).forEach(entry => {
          const item = this.hoverItems.find(item => item.card === entry.target);
          if (item) this.restHover(item, true);
        });
      });
      this.hoverItems.forEach(item => this.visibilityObserver.observe(item.card));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.resetHover(true);
      }, { signal });
    }

    restHover(item, immediate = false) {
      Object.values(item.to).forEach(to => { to(0); if (immediate) to.tween.progress(1); });
      item.layer.style.removeProperty('will-change');
    }

    resetHover(immediate = false) { this.hoverItems?.forEach(item => this.restHover(item, immediate)); }

    lockOutside() {
      this.inertNodes = [];
      // Walk ancestors, inert only siblings: keep the shared camera and its panel active.
      let node = this.viewport;
      while (node && node !== document.body) {
        [...node.parentElement.children].filter(sibling => sibling !== node && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)).forEach(sibling => {
          this.inertNodes.push([sibling, sibling.inert]); sibling.inert = true;
        });
        node = node.parentElement;
      }
      [...this.world.querySelectorAll('[data-nov-offer]')].forEach(card => {
        const node = card === this.card ? card.querySelector('.cl-nov__body') : card;
        this.inertNodes.push([node,node.inert]); node.inert = true;
      });
    }

    cameraTarget() {
      const stage = this.card.querySelector('[data-nov-camera-target]');
      const rect = stage.getBoundingClientRect(), worldRect = this.world.getBoundingClientRect();
      const currentScale = Number(this.gsap?.getProperty(this.world,'scaleX')) || 1;
      const local = { x:(rect.left-worldRect.left)/currentScale, y:(rect.top-worldRect.top)/currentScale, width:stage.offsetWidth, height:stage.offsetHeight };
      const panel = this.querySelector('.cl-nov__selection').getBoundingClientRect();
      const mobile = innerWidth <= 749;
      const area = mobile ? { x:14, y:54, width:innerWidth-28, height:panel.top-62 } : { x:28, y:90, width:panel.left-56, height:innerHeight-135 };
      const scale = Math.min(area.width/local.width, area.height/local.height, 2.3);
      return { x:area.x+(area.width-local.width*scale)/2-local.x*scale, y:area.y+(area.height-local.height*scale)/2-local.y*scale, scale };
    }

    reframe() {
      this.transition?.kill();
      this.world.style.width = this.anchor.clientWidth + 'px';
      this.anchor.style.height = this.world.offsetHeight + 'px';
      if (this.closing) { this.finishClose(); return; }
      this.gsap?.set(this.world, this.cameraTarget());
      this.setDepth(true, true);
      this.gsap?.set([this.dialog,this.curtain], { opacity:1 });
      this.gsap?.set(this.world.querySelectorAll('.cl-nov__body'), { opacity:0 });
      this.gsap?.set([...this.world.querySelectorAll('[data-nov-offer]')].filter(card => card !== this.card), { opacity:.22 });
    }

    product(index) { return this.slots[index].products.find(product => product.handle === this.slots[index].handle); }

    persist() {
      try { sessionStorage.setItem(this.key, JSON.stringify({ slots: this.slots.map(({ handle, size }) => ({ handle, size })), pending: this.pending })); } catch (_) { /* Selections still persist in memory. */ }
    }

    error(index, text) {
      const field = this.fields[index];
      field.querySelector('[data-slot-error]').textContent = text;
      field.querySelector('[data-slot-sizes]').setAttribute('aria-describedby', field.querySelector('[data-slot-error]').id);
      field.classList.toggle('has-error', Boolean(text));
    }

    renderSlot(index, updateImage = true) {
      const slot = this.slots[index], field = this.fields[index], product = this.product(index);
      this.error(index, '');
      const colors = { 'Bej':'#d5c5a7', 'Siyah':'#171719', 'Ekru':'#eee8d8', 'Beyaz':'#ffffff', 'Antrasit':'#505159', 'Lacivert':'#1c2942', 'Bordo':'#6f233b', 'Buz Mavisi':'#bad2e3', 'Kahverengi':'#76503d', 'Haki':'#787c57', 'Gri':'#a5a5a8', 'Taş Rengi':'#c9bca6', 'Mint':'#afd5c7' };
      const swatches = field.querySelector('[data-slot-swatches]');
      swatches.replaceChildren();
      slot.products.forEach(choice => {
        const button = document.createElement('button'); button.type = 'button';
        button.dataset.slotHandle = choice.handle; button.textContent = choice.color;
        button.style.setProperty('--swatch', colors[choice.color] || '#b2a6ad');
        button.disabled = !choice.variants.some(v => v.available);
        button.setAttribute('aria-pressed', String(choice.handle === slot.handle));
        if (button.disabled) button.setAttribute('aria-label', choice.color + ' — ' + this.strings.sold_out);
        swatches.append(button);
      });
      const sizes = field.querySelector('[data-slot-sizes]');
      sizes.replaceChildren();
      if (!product) { this.error(index, this.strings.unavailable); return; }
      if (!product.variants.some(v => v.size === slot.size && v.available)) slot.size = '';
      product.variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.slotSize = variant.size;
        button.textContent = variant.size;
        button.disabled = !variant.available;
        button.setAttribute('aria-pressed', String(slot.size === variant.size));
        if (!variant.available) { button.setAttribute('aria-label', variant.size + ' — ' + this.strings.sold_out); button.title = this.strings.sold_out; }
        sizes.append(button);
      });
      this.renderSummary(index);
      if (updateImage) slot.loadingImage = this.loadSlotImage(index, product);
    }

    decodeImage(url) {
      if (this.imageCache.has(url)) return this.imageCache.get(url);
      const pending = new Promise((resolve, reject) => {
        const image = new Image();
        const timeout = setTimeout(() => { image.onload = image.onerror = null; reject(new Error('Image timeout')); }, 12000);
        image.onload = async () => {
          try { await image.decode(); clearTimeout(timeout); resolve(image); }
          catch (error) { clearTimeout(timeout); reject(error); }
        };
        image.onerror = () => { clearTimeout(timeout); reject(new Error('Image unavailable')); };
        image.src = url;
      }).catch(error => { this.imageCache.delete(url); throw error; });
      this.imageCache.set(url, pending);
      return pending;
    }

    async loadSlotImage(index, product) {
      const slot = this.slots[index], figure = this.ensemble.children[index], image = figure?.querySelector('img');
      if (!image || !product) return;
      const request = slot.imageRequest = (slot.imageRequest || 0) + 1;
      const status = this.fields[index].querySelector('[data-slot-image-status]');
      figure.dataset.imageLoading = 'true'; figure.setAttribute('aria-busy','true');
      status.textContent = this.strings.image_loading.replace('{color}',product.color);
      this.gsap?.killTweensOf(image);
      try {
        let source = this.opened ? product.imageLarge || product.image : product.image;
        await this.decodeImage(source);
        // Opening while a card photo is in flight must not downgrade the detail.
        if (this.opened && product.imageLarge && source !== product.imageLarge) {
          source = product.imageLarge;
          await this.decodeImage(source);
        }
        if (!this.isConnected || request !== slot.imageRequest || product.handle !== slot.handle) return;
        // Publish the decoded bitmap and its caption together; stale requests never win.
        image.removeAttribute('srcset'); image.src = source; image.alt = product.title;
        image.style.removeProperty('visibility');
        figure.querySelector('figcaption').textContent = product.color;
        slot.displayColor = product.color; slot.displayImage = product.image; slot.displayTitle = product.title;
        this.renderSummary(index);
        status.textContent = '';
        if (this.opened && !this.media.matches) this.gsap?.fromTo(image, { opacity:.65 }, { opacity:1, duration:.18, clearProps:'opacity', overwrite:true });
      } catch (_) {
        if (!this.isConnected || request !== slot.imageRequest) return;
        image.style.visibility = 'hidden';
        figure.querySelector('figcaption').textContent = product.color;
        status.textContent = this.strings.image_error;
      } finally {
        if (request === slot.imageRequest && this.isConnected) { delete figure.dataset.imageLoading; figure.removeAttribute('aria-busy'); }
      }
    }

    renderSummary(index) {
      const slot=this.slots[index], product=this.product(index), tab=this.tabs[index];
      if (!product || !tab) return;
      const color=slot.displayColor || product.color;
      const text=color+' / '+(slot.size || this.strings.choose_size);
      this.fields[index].querySelector('[data-slot-selection]').textContent=text;
      tab.querySelector('[data-summary-selection]').textContent=text;
      tab.classList.toggle('is-ready',product.variants.some(v=>v.size===slot.size && v.available));
      const thumb=tab.querySelector('img'); thumb.src=slot.displayImage || product.image; thumb.hidden=false;
      this.ensemble.children[index]?.querySelector('[data-stage-edit]')?.setAttribute('aria-label',this.strings.select_product+': '+(slot.displayTitle || product.title));
    }

    setActive(index, focusSummary = false) {
      if (!this.fields[index] || this.busy) return;
      this.activeSlot=index;
      this.fields.forEach((field,i)=>{field.hidden=i!==index;});
      this.tabs.forEach((tab,i)=>tab.setAttribute('aria-expanded',String(i===index)));
      this.ensemble.querySelectorAll('[data-stage-edit]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      this.querySelector('.cl-nov__slots').scrollTop=0;
      this.updateLighting();
      if (focusSummary) this.tabs[index].focus({preventScroll:true});
    }

    updateLighting(immediate = false) {
      const ready=this.slots.every((slot,i)=>this.product(i)?.variants.some(v=>v.available && v.size===slot.size));
      const duration=immediate || this.media.matches ? 0 : .3;
      if (!this.gsap) return;
      this.gsap.to(this.productLight,{xPercent:ready?0:(this.activeSlot-1)*28,scaleX:ready?1.3:.6,opacity:this.opened ? .85 : 0,duration,overwrite:true});
      [...this.ensemble.children].forEach((figure,i)=>this.gsap.to(figure.querySelector('.cl-nov__cutout'),{scale:!this.opened || ready?1:i===this.activeSlot?1.035:.96,duration,overwrite:true}));
    }

    setDepth(open, immediate = false) {
      const duration=immediate || this.media.matches ? 0 : open ? .9 : .8;
      this.gsap?.to(this.depth.back,{scale:open?1.025:1,y:open?6:0,duration,ease:'power3.inOut',overwrite:true});
      this.gsap?.to(this.depth.mid,{scale:open?1.08:1,y:open?10:0,duration,ease:'power3.inOut',overwrite:true});
      this.gsap?.to(this.depth.front,{scale:open?1.32:1,y:open?-14:0,duration,ease:'power3.inOut',overwrite:true});
    }

    warmImages() {
      return Promise.allSettled(this.slots.map((slot,index) => {
        const product = this.product(index);
        return product ? this.decodeImage(product.imageLarge || product.image) : Promise.resolve();
      }));
    }

    promoteImages() {
      return Promise.all(this.slots.map(async (slot,index)=>{
        const product=this.product(index), request=slot.imageRequest;
        if (!product?.imageLarge) return;
        try {
          await Promise.all([slot.loadingImage, this.decodeImage(product.imageLarge)]);
          if (!this.isConnected || !this.opened || slot.handle!==product.handle || slot.imageRequest!==request) return;
          const image=this.ensemble.children[index].querySelector('img');
          image.removeAttribute('srcset'); image.src=product.imageLarge;
        } catch (_) { /* Keep the decoded smaller photo if the detail image fails. */ }
      }));
    }

    updateSummary() {
      const amount = this.slots.reduce((sum, slot, index) => {
        const product = this.product(index);
        return sum + (product?.variants.find(v => v.size === slot.size)?.price || product?.variants[0]?.price || 0);
      }, 0);
      this.querySelector('[data-w1-current]').textContent = money(amount);
      const campaign=Number(this.card.querySelector('[data-nov-price]').dataset.novPrice)*100;
      const advantage=amount-campaign;
      this.querySelector('[data-w1-total]').textContent = money(campaign);
      this.card.querySelector('[data-nov-regular]').textContent=money(amount);
      this.card.querySelector('[data-nov-comparison]').hidden=!amount;
      const planned=advantage>0?money(advantage)+' '+this.strings.advantage:'';
      this.card.querySelector('[data-nov-advantage]').textContent=planned;
      this.card.querySelector('[data-nov-advantage]').hidden=advantage<=0;
      this.querySelector('[data-w1-advantage]').textContent=planned;
      this.querySelector('[data-w1-state]').textContent = this.card.querySelector('[data-nov-status]').textContent;
      this.querySelector('[data-w1-dates]').textContent = this.card.querySelector('.cl-nov__dates').textContent.trim();
      this.querySelector('.cl-nov__selection-header h2').textContent = this.card.querySelector('.cl-nov__title').textContent;
      this.querySelector('[data-w1-note]').textContent = this.strings.price_notice;
      const count=this.slots.filter((slot,i)=>this.product(i)?.variants.some(v=>v.available && v.size===slot.size)).length;
      this.querySelector('[data-w1-ready]').textContent=this.strings.ready.replace('{count}',count).replace('{total}',this.slots.length);
      this.querySelector('.cl-nov__buybar').classList.toggle('is-ready',count===this.slots.length);
      if (this.lastReadyCount!==count) { this.lastReadyCount=count; this.updateLighting(); }
      if (!this.busy) this.add.textContent = this.pending ? this.strings.reconcile : this.strings.add;
    }

    async open(trigger) {
      if (this.opened && !this.closing) return;
      this.transition?.kill();
      if (!this.opened) {
        this.trigger = trigger;
        this.scroll = { x: window.scrollX, y: window.scrollY };
        this.previousOverflow = document.documentElement.style.overflow;
        this.previousGutter = document.documentElement.style.scrollbarGutter;
        const rect = this.viewport.getBoundingClientRect();
        this.anchor.style.height = rect.height + 'px';
        this.world.style.width = rect.width + 'px';
        this.viewport.classList.add('is-focused');
        // Promote the whole existing scene; no product node is cloned or reparented.
        if (this.viewport.showPopover) { this.viewport.setAttribute('popover','manual'); this.viewport.showPopover(); }
        this.gsap?.set(this.world, { x:rect.left, y:rect.top, scale:1 });
        this.lockOutside();
        document.documentElement.style.scrollbarGutter = 'stable';
        document.documentElement.style.overflow = 'hidden';
        this.dialog.hidden = false;
        this.viewport.setAttribute('role','dialog'); this.viewport.setAttribute('aria-modal','true');
        this.viewport.setAttribute('aria-labelledby',this.dialog.getAttribute('aria-labelledby'));
        this.ensemble.querySelectorAll('[data-stage-edit]').forEach(button=>button.tabIndex=0);
        this.gsap?.set([this.dialog,this.curtain], { opacity:0 });
      }
      this.card.dataset.sceneActive = 'true';
      this.opened = true; this.closing = false;
      const opening = this.openRequest = (this.openRequest || 0) + 1;
      // Decode before the camera grows. The existing card stays visible while
      // loading, and Escape/close/reopen invalidates this continuation.
      this.viewport.setAttribute('aria-busy','true');
      await this.promoteImages();
      if (!this.isConnected || !this.opened || this.closing || opening !== this.openRequest) return;
      this.viewport.removeAttribute('aria-busy');
      this.setDepth(true);
      this.updateLighting();
      this.resetHover();
      this.updateSummary();
      const duration = this.media.matches ? 0 : .95;
      const bodies = this.world.querySelectorAll('.cl-nov__body');
      const neighbors = [...this.world.querySelectorAll('[data-nov-offer]')].filter(card => card !== this.card);
      if (this.gsap) {
        this.transition = this.gsap.timeline({ defaults:{ ease:'power3.inOut' } })
          .to(this.world, { ...this.cameraTarget(), duration }, 0)
          .to(this.curtain, { opacity:1, duration:duration*.75 }, 0)
          .to(bodies, { opacity:0, duration:duration*.5 }, 0)
          .to(neighbors, { opacity:.22, duration:duration*.6 }, 0)
          .to(this.dialog, { opacity:1, duration:duration*.35 }, duration*.6);
      } else {
        Object.assign(this.world.style,{ transform:`translate(${this.cameraTarget().x}px, ${this.cameraTarget().y}px) scale(${this.cameraTarget().scale})` });
        bodies.forEach(body=>body.style.opacity='0');
      }
      this.querySelector('[data-w1-close]').focus({ preventScroll:true });
    }

    close(immediate = false) {
      if (!this.opened || this.closing) return;
      this.openRequest = (this.openRequest || 0) + 1;
      this.viewport.removeAttribute('aria-busy');
      this.closing = true;
      this.setDepth(false,immediate);
      this.gsap?.to(this.productLight,{opacity:0,duration:this.media.matches || immediate?0:.4,overwrite:true});
      this.transition?.kill();
      if (immediate || this.media.matches || !this.gsap) { this.finishClose(); return; }
      const rect = this.anchor.getBoundingClientRect();
      this.transition = this.gsap.timeline({ onComplete:()=>this.finishClose(), defaults:{ ease:'power3.inOut' } })
        .to(this.dialog, { opacity:0, duration:.16 }, 0)
        .to(this.curtain, { opacity:0, duration:.75 }, 0)
        .to(this.world, { x:rect.left, y:rect.top, scale:1, duration:.8 }, 0)
        .to(this.world.querySelectorAll('[data-nov-offer]'), { opacity:1, duration:.65 }, 0)
        .to(this.world.querySelectorAll('.cl-nov__body'), { opacity:1, duration:.25 }, .5);
    }

    finishClose(restoreFocus = true) {
      delete this.card.dataset.sceneActive;
      this.opened = false; this.closing = false;
      this.openRequest = (this.openRequest || 0) + 1;
      this.viewport.removeAttribute('aria-busy');
      this.setDepth(false,true); this.updateLighting(true);
      ['role','aria-modal','aria-labelledby'].forEach(name=>this.viewport.removeAttribute(name));
      this.ensemble.querySelectorAll('[data-stage-edit]').forEach(button=>button.tabIndex=-1);
      if (this.viewport.showPopover && this.viewport.matches(':popover-open')) this.viewport.hidePopover();
      this.viewport.removeAttribute('popover'); this.viewport.classList.remove('is-focused');
      this.dialog.hidden = true;
      this.gsap?.set([this.world,this.dialog,this.curtain,...this.world.querySelectorAll('.cl-nov__body,[data-nov-offer]')],{ clearProps:'transform,opacity' });
      if (!this.gsap) this.world.querySelectorAll('.cl-nov__body').forEach(body => body.style.removeProperty('opacity'));
      this.world.style.removeProperty('width'); this.world.style.removeProperty('transform');
      this.anchor.style.removeProperty('height'); this.world.inert = false;
      this.inertNodes?.forEach(([node,wasInert])=>node.inert=wasInert); this.inertNodes=[];
      document.documentElement.style.overflow = this.previousOverflow || '';
      document.documentElement.style.scrollbarGutter = this.previousGutter || '';
      if (restoreFocus && this.scroll) {
        window.scrollTo({ left:this.scroll.x, top:this.scroll.y, behavior:'instant' });
        this.trigger?.focus({ preventScroll:true });
      }
    }

    async json(path, options = {}) {
      const root = window.Shopify?.routes?.root || '/';
      const fetcher = window.__clCartOriginalFetch || window.fetch.bind(window);
      const freshPath = options.method ? path : path + (path.includes('?') ? '&' : '?') + 'cl_nov_read=' + crypto.randomUUID();
      const response = await fetcher(root + freshPath, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000), ...options, headers: { Accept: 'application/json', ...options.headers } });
      const data = await response.json();
      if (!response.ok) { const error = new Error(data.description || data.message || this.strings.not_added); error.status = response.status; throw error; }
      return data;
    }

    matched(cart, attempt) {
      return attempt.items.every(expected => cart.items.filter(item => item.properties?._cl_nov_attempt === attempt.id && Number(item.variant_id) === expected.id).reduce((sum, item) => sum + item.quantity, 0) >= expected.quantity);
    }

    async showCart(cart) {
      if (window.CraftlabelCart?.presentVerified) {
        const current = await window.CraftlabelCart.presentVerified(cart, () => this.close(true));
        if (!current) {
          this.feedback.textContent = this.strings.check_result;
          this.cartLink.hidden = false;
          return;
        }
        cart = current;
      } else if (window.CraftlabelCart?.refresh) {
        // Keep the scene covering the drawer until its current render is ready.
        const current = await window.CraftlabelCart.refresh({ open:false, silent:true });
        if (!current) { this.feedback.textContent=this.strings.check_result; this.cartLink.hidden=false; return; }
        this.close(true); window.CraftlabelCart.open?.(); cart=current;
      } else {
        this.close(true);
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
      document.querySelectorAll('cart-count').forEach(node => { node.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count); node.hidden = cart.item_count === 0; });
      document.documentElement.classList.toggle('cart-has-items', cart.item_count > 0);
    }

    async reconcile() {
      try {
        const cart = await this.json('cart.js');
        if (this.matched(cart, this.pending)) {
          this.pending = null; this.persist();
          this.feedback.textContent = this.strings.success.replace('{total}', money(cart.total_price));
          await this.showCart(cart);
        } else {
          this.feedback.textContent = this.strings.uncertain;
          this.cartLink.hidden = false;
          await this.showCart(cart);
        }
      } catch (_) { this.feedback.textContent = this.strings.uncertain; this.cartLink.hidden = false; }
    }

    async submit() {
      if (this.busy) return;
      if (!this.pending) {
        let firstMissing = -1;
        this.slots.forEach((slot, index) => {
          if (!this.product(index)?.variants.some(variant => variant.size === slot.size && variant.available)) {
            this.error(index, this.strings.missing);
            if (firstMissing < 0) firstMissing = index;
          }
        });
        if (firstMissing >= 0) { this.setActive(firstMissing); this.fields[firstMissing].querySelector('button:not(:disabled)')?.focus(); return; }
      }
      this.busy = true;
      this.add.disabled = true;
      this.add.textContent = this.strings.adding;
      this.form.setAttribute('aria-busy', 'true');
      this.feedback.textContent = '';
      this.cartLink.hidden = true;
      this.fields.forEach(field => { field.disabled = true; });
      let sent = false;
      try {
        if (this.pending) { await this.reconcile(); return; }
        const before = await this.json('cart.js');
        if (before.currency !== 'TRY') throw new Error(this.strings.currency_error);
        const handles = [...new Set(this.slots.map(slot => slot.handle))];
        const fresh = await Promise.all(handles.map(handle => this.json('products/' + encodeURIComponent(handle) + '.js')));
        let stale = -1;
        const variants = this.slots.map((slot, index) => {
          const old = this.product(index).variants.find(variant => variant.size === slot.size);
          const variant = fresh.find(product => product.handle === slot.handle)?.variants.find(variant => variant.id === old.id);
          if (!variant?.available) { old.available = false; slot.size = ''; this.renderSlot(index, false); this.error(index, this.strings.stock_error); stale = index; }
          return old;
        });
        if (stale >= 0) { this.persist(); this.focusAfterRequest = stale; return; }
        const items = aggregate(variants);
        const id = crypto.randomUUID();
        this.pending = { id, items };
        this.persist();
        sent = true;
        await this.json('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items.map(item => ({ ...item, properties: { _cl_nov_attempt: id } })) }) });
        const cart = await this.json('cart.js');
        if (!this.matched(cart, this.pending)) throw new Error(this.strings.not_added);
        this.pending = null; this.persist();
        this.feedback.textContent = this.strings.success.replace('{total}', money(cart.total_price));
        await this.showCart(cart);
      } catch (error) {
        if (!sent) this.feedback.textContent = error.status || error.message === this.strings.currency_error ? error.message : this.strings.network_error;
        else {
          try {
            const cart = await this.json('cart.js');
            if (this.matched(cart, this.pending)) {
              this.pending = null; this.persist();
              this.feedback.textContent = this.strings.success.replace('{total}', money(cart.total_price));
              await this.showCart(cart);
            } else {
              const any = cart.items.some(item => item.properties?._cl_nov_attempt === this.pending.id);
              if (error.status && !any) { this.pending = null; this.persist(); this.feedback.textContent = error.message; }
              else { this.feedback.textContent = this.strings.uncertain; this.cartLink.hidden = false; }
            }
          } catch (_) { this.feedback.textContent = this.strings.uncertain; this.cartLink.hidden = false; }
        }
      } finally {
        this.busy = false;
        this.add.disabled = false;
        this.fields.forEach(field => { field.disabled = false; });
        if (Number.isInteger(this.focusAfterRequest)) { this.setActive(this.focusAfterRequest); this.fields[this.focusAfterRequest].querySelector('button:not(:disabled)')?.focus(); this.focusAfterRequest = null; }
        this.form.removeAttribute('aria-busy');
        this.updateSummary();
      }
    }
  }
  customElements.define('cl-november-shop', NovemberShop);
})();
